<template>
  <div class="column">
    <p class="primary-text">{{ label }}</p>
    <QSelect
      class="calculator-multiselect"
      color="secondary"
      outlined
      v-model="model"
      use-input
      use-chips
      multiple
      input-debounce="0"
      dense
      stack-label
      autocomplete
      :options="filterOptions"
      @filter="filterFn"
      ref="mySelect"
      :disabled="disabled"
    >
      <template v-slot:no-option>
        <QItem>
          <QItemSection class="text-grey"> No results </QItemSection>
        </QItem>
      </template>
    </QSelect>
  </div>
</template>

<script>
import { QSelect, QItem, QItemSection } from 'quasar';

export default {
  name: 'RefineSearchMultiSelect',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: 'Toyota'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.value,
      filterOptions: [],
      stringOptions: []
    };
  },
  watch: {
    value(newVal) {
      this.model = newVal;
    },
    options(value) {
      this.stringOptions = value.map((option) => option.label || option);
    },
    model(value) {
      this.$emit('input', value);
      this.$emit('model-updated', value);
    }
  },
  methods: {
    filterFn(val, update) {
      update(() => {
        if (val === '') {
          this.filterOptions = this.stringOptions;
        } else {
          const needle = val.toLowerCase();
          this.filterOptions = this.stringOptions.filter((v) => v.toLowerCase().indexOf(needle) > -1);
        }
      });
    }
  },
  created() {
    this.stringOptions = this.options.map((option) => option.label || option);
  },
  components: {
    QSelect,
    QItem,
    QItemSection
  }
};
</script>

<style lang="sass" computed>
.calculator-multiselect
  .q-field__control:has(.q-chip), .q-field__marginal, &.q-field--auto-height .q-field__control:has(.q-chip), &.q-field--auto-height .q-field__native:has(.q-chip)
    height: auto
  .q-field__control
    border: 1px solid #616161;
    border-radius: 6px;
    .q-chip
      background: $secondary
      span
        color: #FFFFFF
</style>
